import { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import { Controller, useFormContext } from 'react-hook-form';

import TextField from '@mui/material/TextField';

// ----------------------------------------------------------------------

export function RHFMaskField({ name, helperText, type, mask, ...other }) {
  const { control } = useFormContext();
  const maskProps = {
    mask
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          type={type}
          slotProps={{
            input: {
              inputComponent: TextMaskCustom,
              inputProps: maskProps
            }
          }}
          error={!!error}
          helperText={error?.message ?? helperText}
          {...other}
        />
      )}
    />
  );
}


const TextMaskCustom = forwardRef(
  function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        definitions={{
          '#': /[0-9]/,
        }}
        inputRef={ref}
        // remove any non alphanumeric characters
        onAccept={(value) => onChange({ target: { name: props.name, value: value.replace(/[^a-zA-Z0-9]/g, '') } })}
        overwrite
        {...other}
      />
    );
  },
);
